module.exports = __webpack_public_path__ + "img/pk.de424f77.svg";